import { Breakpoint, Color, Input } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { MessageContainerProps } from './calculation.types';

export const Container = styled.div`
  width: 100%;
  padding: 20px 24px;
  background-color: ${Color.Gray300};
`;

export const InputsContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-direction: column;

  @media ${Breakpoint.Tablet} {
    flex-direction: row;
    gap: 16px;
  }
`;

export const MessageContainer = styled.div<MessageContainerProps>`
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ $bgColor }: MessageContainerProps): Color => $bgColor};
  margin-top: 24px;
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;
